import { Box, type BoxProps, useBreakpointValue } from '@chakra-ui/react';

export const MainColumn = (props: BoxProps) => {
  const { children } = props;

  const isLargeScreen = useBreakpointValue({ base: false, md: true });

  return (
    <Box
      as="main"
      id="main"
      flexGrow={1}
      flexShrink={1}
      px={{ base: 4, md: 6, xl: 8, '2xl': 12 }}
      py={{ base: 4, md: 6 }}
      height={{ md: '100%' }}
      overflowY={{ md: 'auto' }}
      className={isLargeScreen && 'nav-scrollbar'}
      {...props}
    >
      <Box maxWidth={'5xl'} mx={'auto'}>
        {children}
      </Box>
    </Box>
  );
};
